var noop = function noop() {
  return undefined;
};

var factory = function factory(url, type) {
  return function (payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: "data=".concat(encodeURIComponent(JSON.stringify({
        type: type,
        payload: payload
      }))),
      mode: 'cors',
      credentials: 'omit'
    });
  };
};

export default (function (url) {
  return {
    install: noop,
    uninstall: noop,
    trackPageView: factory(url, 'pageView'),
    trackEvent: factory(url, 'event')
  };
});
//# sourceMappingURL=es/dataCenter.js.map